import { ConfiguratorConfig, ConfigurationsRegistry } from '@icc/configurator/types';
import { RollerShutterActiveConfiguration } from './roller-shutter-active-configuration';
import { RollerShutterConfiguration } from './roller-shutter-configuration';
import { ExternalBlindActiveConfiguration } from './external-blind-active-configuration';
import { ExternalBlindConfiguration } from './external-blind-configuration';

export const ROLLER_SHUTTER_CONFIGURATOR_CONFIG: ConfiguratorConfig = {
    type: 'roller_shutter',
    activeConfigurationClass: RollerShutterActiveConfiguration,
    configurationClass: RollerShutterConfiguration
};

export const EXTERNAL_BLIND_CONFIGURATOR_CONFIG: ConfiguratorConfig = {
    type: 'external_blind',
    activeConfigurationClass: ExternalBlindActiveConfiguration,
    configurationClass: ExternalBlindConfiguration
};

/**
 * Rejestruje wszystkie konfiguracje shutter w Registry
 * Używane przez frontend (Angular module) i backend (APP_INITIALIZER)
 */
export function registerShutterConfigurations(): void {
    ConfigurationsRegistry.register(ROLLER_SHUTTER_CONFIGURATOR_CONFIG);
    ConfigurationsRegistry.register(EXTERNAL_BLIND_CONFIGURATOR_CONFIG);
}
